import React, { FC, ReactNode, useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Collapse as CollapseContent,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { ExpandMore } from 'src/components/Collapse/./styled';
import {
  CollapseHeader,
  Container,
} from 'src/components/Collapse/FormulaCollapse/styled';

interface FormulaCollapseProps {
  title: string;
  children: ReactNode;
  onEdit: () => void;
  onDelete: () => void;
}

export const FormulaCollapse: FC<FormulaCollapseProps> = ({
  title,
  children,
  onEdit,
  onDelete,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => setExpanded(!expanded);

  return (
    <>
      <CollapseHeader>
        <Box display="flex" gap="10px">
          <Typography>{title}</Typography>
          <ExpandMore expand={+expanded} onClick={handleExpandClick}>
            <ArrowDropDownIcon />
          </ExpandMore>
        </Box>
        <Box display="flex" gap="20px">
          <IconButton onClick={onEdit}>
            <CreateIcon />
          </IconButton>
          <IconButton onClick={onDelete}>
            <DeleteIcon />
          </IconButton>
        </Box>
      </CollapseHeader>
      <CollapseContent in={expanded} timeout="auto" unmountOnExit>
        <Container>{children}</Container>
      </CollapseContent>
      <Divider />
    </>
  );
};
